import { useEffect, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { RichEditor } from "@/components/rich/RichEditor";
import { api } from "@/lib/api";

export const OfflineNotes = ({ ent, canEdit, onMarkdown }) => {
  const qc = useQueryClient();
  const [value, setValue] = useState(ent.content || "");
  const [state, setState] = useState("saved");
  const pending = useRef(null);
  const t = useRef(null);
  const save = async () => {
    const md = pending.current;
    if (md == null) return;
    pending.current = null;
    await api.patch(`/entities/${ent.id}`, { content: md }).catch(() => {});
    setState(pending.current == null ? "saved" : "dirty");
    qc.invalidateQueries({ queryKey: ["entities", ent.universe_id] });
  };
  useEffect(() => () => { clearTimeout(t.current); save(); }, [ent.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const change = (md) => {
    if (md === value) return;
    setValue(md);
    onMarkdown(md);
    pending.current = md;
    setState("dirty");
    clearTimeout(t.current);
    t.current = setTimeout(save, 800);
  };
  return (
    <div data-testid="offline-notes">
      <div className="mb-1 flex justify-end text-[11px] text-[#F59E0B]" data-testid="offline-notes-status">{state === "saved" ? "Saved on this device" : "Saving on this device…"}</div>
      <RichEditor value={value} onChange={change} disabled={!canEdit} testid="offline-notes-editor" placeholder="Write the history, appearance, secrets…" />
    </div>
  );
};
